<div class="mb-3">
  <div class="form-group col-12">
    <div class="row">
      <div class="col-12 col-sm-6"
           [innerHTML]="translationService.getTranslation('name') + ': ' + person.addressCodeDescription + ' ' + person.titleDescription + ' ' + person.firstname + ' ' + person.lastname"></div>
    </div>
  </div>
  <div class="form-group col-12">
    <div class="row">
      <div class="col-12 col-sm-6"
           [innerHTML]="translationService.getTranslation('address_street') + ': ' + address.street + ' ' + (address.houseno | houseNoPipe)"></div>
    </div>
  </div>
  <div class="form-group col-12">
    <div class="row">
      <div class="col-12 col-sm-6"
           [innerHTML]="translationService.getTranslation('address_postcode') + ': ' + address.zipcode"></div>
    </div>
  </div>
  <div class="form-group col-12">
    <div class="row">
      <div class="col-12 col-sm-6"
           [innerHTML]="translationService.getTranslation('address_city') + ': ' + address.city + ', ' + address.countryDescription"></div>
    </div>
  </div>
</div>
